import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import colors from "assets/theme/base/colors";

function Breadcrumbs({ icon, title, route, light }) {
  const routes = route.slice(0, -1);
  const { sideNav } = colors;

  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) =>
              light ? white.main : `${sideNav.hoverTextColor}`,
          },
        }}
      >
        <Link to="/">
          <MDBox
            fontSize="16px"
            color={light ? "white" : `${sideNav.hoverTextColor}`}
            opacity={light ? 0.8 : 0.6}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDBox>
        </Link>
        {routes.map((el) => (
          <Link to={`/${el}`} key={el}>
            <MDBox
              fontSize="16px"
              fontWeight="500"
              textTransform="capitalize"
              color={light ? "white" : `${sideNav.hoverTextColor}`}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el}
            </MDBox>
          </Link>
        ))}
        <MDBox
          fontSize="14px"
          fontWeight="500"
          textTransform="capitalize"
          color={light ? "white" : `${sideNav.hoverTextColor}`}
          sx={{ lineHeight: 0 }}
        >
          {title.replace("-", " ")}
        </MDBox>
      </MuiBreadcrumbs>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
